import { anatomyFromExtractDetails, validateAnatomyTypes } from "@/lib/anatomyTypes";

/** Modalities that require anatomy type + CT reviewer when creating a study. */
const CT_STUDY_FIELD_MODALITIES = new Set(["3mensio_ct", "ct_report"]);

const hasStandalonePatientIdentity = (details) => {
  const uhid = String(details?.patient_id || details?.system_uhid || "").trim();
  const name = String(details?.name || "").trim();
  const hasAge = (details?.age != null && String(details.age).trim() !== "")
    || Boolean(String(details?.date_of_birth ?? "").trim());
  return Boolean(uhid && name && hasAge);
};

const hasRequiredStudyFields = (file) => {
  const modality = file?.modality || "";
  if (!CT_STUDY_FIELD_MODALITIES.has(modality)) return true;
  const fields = {
    ...(anatomyFromExtractDetails(file?.anatomy_details) || {}),
    ...(file?.study_fields || {}),
  };
  if (validateAnatomyTypes(fields)) return false;
  if (!String(fields.ct_reviewer ?? "").trim()) return false;
  return true;
};

/** File queued from /upload (not Patients → Add Study). */
export const isStandaloneUploadFile = (file) => {
  if (!file) return false;
  if (file.origin === "add_study" || file.queue === "add_study" || file.locked_patient_uhid) {
    return false;
  }
  if (
    file.mismatch_kind === "add_study_exists"
    || file.mismatch_kind === "add_study_new"
    || file.mismatch_kind === "locked"
  ) {
    return false;
  }
  return file.origin === "upload" || file.queue === "upload";
};

/**
 * Standalone /upload extract that cannot auto-save (new / unknown patient,
 * missing identity, or missing CT study fields). Show Mismatch like Add Study.
 */
export const needsStandaloneNewPatientReview = (file) => {
  if (file?.status !== "extracted") return false;
  if (!isStandaloneUploadFile(file)) return false;
  if (file.mismatch_kind === "exists" || file.patient_details?.exists === true) return false;
  if (file.patient_mismatch && file.mismatch_kind === "new") return true;
  return !hasStandalonePatientIdentity(file.patient_details) || !hasRequiredStudyFields(file);
};

export const standaloneNewPatientMismatchPatch = () => ({
  patient_mismatch: true,
  mismatch_kind: "new",
  mismatch_patient_uhid: "",
  queue: "upload",
  origin: "upload",
  locked_patient_uhid: "",
});
